/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Origin } from './Origin';
import {
    OriginFromJSON,
    OriginFromJSONTyped,
    OriginToJSON,
    OriginToJSONTyped,
} from './Origin';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetApprovedMakeupRosterEntryResponse
 */
export interface GetApprovedMakeupRosterEntryResponse {
    /**
     * 
     * @type {string}
     * @memberof GetApprovedMakeupRosterEntryResponse
     */
    makeupSessionId: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetApprovedMakeupRosterEntryResponse
     */
    studentId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GetApprovedMakeupRosterEntryResponse
     */
    studentName: string;
    /**
     * 
     * @type {Date}
     * @memberof GetApprovedMakeupRosterEntryResponse
     */
    approvedDate: Date;
    /**
     * 
     * @type {string}
     * @memberof GetApprovedMakeupRosterEntryResponse
     */
    approvedStartTime: string;
    /**
     * 
     * @type {string}
     * @memberof GetApprovedMakeupRosterEntryResponse
     */
    approvedEndTime: string;
    /**
     * 
     * @type {Origin}
     * @memberof GetApprovedMakeupRosterEntryResponse
     */
    origin: Origin;
}



/**
 * Check if a given object implements the GetApprovedMakeupRosterEntryResponse interface.
 */
export function instanceOfGetApprovedMakeupRosterEntryResponse(value: object): value is GetApprovedMakeupRosterEntryResponse {
    if (!('makeupSessionId' in value) || value['makeupSessionId'] === undefined) return false;
    if (!('studentId' in value) || value['studentId'] === undefined) return false;
    if (!('studentName' in value) || value['studentName'] === undefined) return false;
    if (!('approvedDate' in value) || value['approvedDate'] === undefined) return false;
    if (!('approvedStartTime' in value) || value['approvedStartTime'] === undefined) return false;
    if (!('approvedEndTime' in value) || value['approvedEndTime'] === undefined) return false;
    if (!('origin' in value) || value['origin'] === undefined) return false;
    return true;
}

export function GetApprovedMakeupRosterEntryResponseFromJSON(json: any): GetApprovedMakeupRosterEntryResponse {
    return GetApprovedMakeupRosterEntryResponseFromJSONTyped(json, false);
}

export function GetApprovedMakeupRosterEntryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetApprovedMakeupRosterEntryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'makeupSessionId': json['makeupSessionId'],
        'studentId': ApiUserTasksGetPageParameterFromJSON(json['studentId']),
        'studentName': json['studentName'],
        'approvedDate': (new Date(json['approvedDate'])),
        'approvedStartTime': json['approvedStartTime'],
        'approvedEndTime': json['approvedEndTime'],
        'origin': OriginFromJSON(json['origin']),
    };
}

export function GetApprovedMakeupRosterEntryResponseToJSON(json: any): GetApprovedMakeupRosterEntryResponse {
    return GetApprovedMakeupRosterEntryResponseToJSONTyped(json, false);
}

export function GetApprovedMakeupRosterEntryResponseToJSONTyped(value?: GetApprovedMakeupRosterEntryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'makeupSessionId': value['makeupSessionId'],
        'studentId': ApiUserTasksGetPageParameterToJSON(value['studentId']),
        'studentName': value['studentName'],
        'approvedDate': value['approvedDate'].toISOString().substring(0,10),
        'approvedStartTime': value['approvedStartTime'],
        'approvedEndTime': value['approvedEndTime'],
        'origin': OriginToJSON(value['origin']),
    };
}

